module.exports = __webpack_public_path__ + "img/aptitude13.1b29af5a.jpg";